<template>

  <div style="background: #f2f2f6; height: 100%">
   <el-row style="height:100%"><el-col :span="14"> <el-form style="padding-bottom: 30px !important;" size="mini" label-width="100px" class="demo-form-inline">

       <el-form-item :label="$t('device.changeProtocol')">
          <el-cascader
          filterable
    v-model="protocol"
    clearable
    :show-all-levels="true"
    :options="factorys.filter(x=>{return x.protocols&&x.protocols.length>0})"
    :props="{ expandTrigger: 'hover',value:'innerid',label:'name',children:'protocols',emitPath:false }"
    ></el-cascader>
     <el-button size="mini" type="primary"  @click="protocolUpdate()">{{$t('base.confirm')}}</el-button>
  </el-form-item>
  <el-form-item v-if="false" :label="$t('device.heatpumpVersionUpdate')">
    <el-select
          v-model="version"
          size="mini"
          :placeholder="$t('device.heatpumpVersionUpdate')">
            <el-option v-for="v in versions" :label="v.version" :value="v.innerid" :key="v.innerid"></el-option>
          </el-select>
     <el-button size="mini" type="primary"  @click="upload()">{{$t('base.update')}}</el-button>
     <el-progress v-if="$store.state.device.status==0" :percentage="$store.state.device.percentage||0"></el-progress>
              <span v-else-if="$store.state.device.status==1" style="color:green">{{$t('device.updateVersionSuccess')}}</span>
              <span v-else-if="$store.state.device.status==2" style="color:green">{{$t('device.noNeedUpdateVserion')}}</span>
              <span v-else-if="$store.state.device.status==3" style="color:red">{{$t('device.updateVersionOffline')}}</span>
              <span v-else-if="$store.state.device.status==-1" style="color:red">{{$t('device.updateVersionFial')}}</span>
              <span v-else style="color:gray">{{$t('device.notStartVersionUpdate')}}</span>
  </el-form-item>
  <el-row>
      <el-form-item :label="$t('device.rebootGateway')">
    <el-button icon="el-icon-s-data" type="primary" @click="reboot()">{{$t('base.reboot')}}</el-button>
    <el-button icon="el-icon-map-location" type="primary" @click="reflocat()">重定位</el-button>
    <el-button icon="el-icon-s-data" type="primary" @click="sync()">数据同步</el-button>
    <el-button icon="el-icon-s-promotion" type="primary" @click="sendMessage()">数据发送</el-button>
  </el-form-item>
  <el-form-item :label="$t('device.debugger')" v-if="user.logintype!=2&& $i18n.locale=='zh'">
    <el-button icon="el-icon-cpu" type="primary" @click="$store.state.debugger=true">{{$t('device.debugger')}}</el-button>
  </el-form-item>
  <el-form-item :label="$t('device.gatewayUpdate')">
   <span style="color:#606266;margin-right:10px"> {{ $store.state.project.firmwareverson }}</span>
   <el-button @click="updatemiBee()" v-if="$store.state.project.online===1" icon="el-icon-upload2" type="primary"  >{{$t('base.update')}}</el-button>
  </el-form-item>
    </el-row>
    <el-form-item :label="$t('device.reportInterval')">
    <el-select v-model="$store.state.project.reportinterval" @change="$forceUpdate()">
            <el-option  :label="'5'+$t('base.second')" :value="5" ></el-option>
            <el-option  :label="'10'+$t('base.second')" :value="10" ></el-option>
            <el-option  :label="'20'+$t('base.second')" :value="20" ></el-option>
            <el-option  :label="'30'+$t('base.second')" :value="30" ></el-option>
            <el-option  :label="'40'+$t('base.second')" :value="40" ></el-option>
            <el-option  :label="'50'+$t('base.second')" :value="50" ></el-option>
            <el-option  :label="'1'+$t('base.minute')" :value="60" ></el-option>
            <el-option  :label="'2'+$t('base.minutes')"  :value="120" ></el-option>
            <el-option  :label="'5'+$t('base.minutes')"  :value="300" ></el-option>
            <el-option  :label="'10'+$t('base.minutes')"  :value="600" ></el-option>
            <el-option  :label="'15'+$t('base.minutes')"  :value="900" ></el-option>
            <el-option  :label="'30'+$t('base.minutes')"  :value="1800" ></el-option>
            <el-option  :label="'1'+$t('base.hour')" :value="3600" ></el-option>
          </el-select>
     <el-button size="mini" type="primary"  @click="updateEquipment(['reportinterval'])">{{$t('base.confirm')}}</el-button>
  </el-form-item>
  <el-form-item :label="$t('device.reportTime')">
    <el-time-picker
    :clearable="false"
    style="width:130px"
    @blur="$forceUpdate()"
    v-model="$store.state.project.startreport"
    format="HH:mm:ss"
    value-format="HH:mm:ss"
    :placeholder="$t('base.beginTime')">
  </el-time-picker>-
  <el-time-picker
  :clearable="false"
    @blur="$forceUpdate()"
    style="width:130px"
    v-model="$store.state.project.endreport"
    format="HH:mm:ss"
    value-format="HH:mm:ss"
    :placeholder="$t('base.endTime')">
  </el-time-picker>
     <el-button  size="mini" type="primary"  @click="updateEquipment(['startreport','endreport'])">{{$t('base.confirm')}}</el-button>
  </el-form-item>
  <el-form-item :label="$t('device.autoReset')">
    <el-switch    v-model="$store.state.project.autoreset"
    active-color="#13ce66"
    inactive-color="#ff4949"
    :active-value="1"
    :inactive-value="0"
    @change="updateEquipment(['autoreset'])"
    >
  </el-switch>
  </el-form-item>
  <el-form-item :label="$t('device.autoResetTime')">
    <el-time-picker
      size="mini"
    :clearable="false"
    style="width:130px"
    @blur="$forceUpdate()"
    v-model="$store.state.project.startreset"
    format="HH:mm:ss"
    value-format="HH:mm:ss"
    :placeholder="$t('base.beginTime')">
  </el-time-picker>-
  <el-time-picker
  :clearable="false"
  size="mini"
    @blur="$forceUpdate()"
    style="width:130px"
    v-model="$store.state.project.endreset"
    format="HH:mm:ss"
    value-format="HH:mm:ss"
    :placeholder="$t('base.endTime')">
  </el-time-picker>
  <el-button  type="primary"  size="mini" style="margin-left:10px" @click="updateEquipment(['startreset','endreset'])">{{$t('base.confirm')}}</el-button>
  </el-form-item>
  <el-form-item :label="$t('device.gatewayLog')">
    <el-table
          id="logtable"
          :data="logdata"
          ref="table"
          border
          stripe
          height="277px"
          style="width: 350px; border-radius: 0 0 10px 10px;font-size:12px"
          :header-cell-style="{ 'text-align': 'center',padding: '5px' }"
          :cell-style="{'line-height': '20px', padding: '5px', 'text-align': 'center' }">
          <template slot="empty">
                 <div>{{$t('device.noOfflineData')}}
              </div>
             </template>
          <el-table-column
            prop="online"
            :label="$t('device.gatewayOnline')" >
            <template slot-scope="scope">
        <span v-if="scope.row.online==1" style="color:green">{{$t('base.online')}}</span>
        <span v-else style="color:red">{{$t('base.offline')}}</span>
        </template>
          </el-table-column>
          <el-table-column
            prop="createdtime"
            :label="$t('device.updatedTime')"
            size="small"
            >
          </el-table-column>
        </el-table>

  </el-form-item>
    </el-form></el-col>
    <el-col style="height:100%;text-align: center;" :span="10">
     
     <el-row id="messagedebugger" style="height:600px;background:#555;margin:10px;margin-top:20px; overflow-y:auto;overflow-x:hidden">
           <span style="color:lightgreen;font-size:18px;margin-top:20px">=== MiBee 网关消息记录 ===</span>
            <el-col style="fonrt-size:16px; padding:3px;color:lightgreen;word-break:break-all;text-align: left;" v-for="(item,i) in $store.state.messagelog" :key="i">{{item}}</el-col>
          </el-row>
    </el-col></el-row>
   

  </div>

</template>

<script>
import Vue from 'vue'

export default {
  name: 'Report',
  data () {
    return {
      user: {},
      updating: false,
      protocol: '',
      factorys: [],
      protocols: [],
      versions: [],
      logdata: [],
      version: '',
      startreport: null,
      messagelog:[]
    }
  },
  computed: {
    heatpump () {
      return this.$store.state.devicelist.filter(d => { return d.type == 'heatpump' })[0]
    }
  },
  mounted: function () {
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      this.user = JSON.parse(customer)
      this.getLoglist()

      let self = this
      Vue.axios
        .post('/factory/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.factorys = res.data.msgbody
            self.factorys.forEach((f) => {
              f.protocols.forEach((p) => {
                let isexisted = self.protocols.filter(x => { return x.innerid == p.innerid })
                if (isexisted.length == 0) {
                  self.protocols.push(p)
                }
              })
            })
            console.log(JSON.stringify(self.protocols))
          } else {
          }
        })
    } else {
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    getLoglist () {
      Vue.axios
        .post('/equipment/logoff/log/list', {innerid: this.$route.params.equipmentid })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.logdata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    },
    timechange (val) {
      console.log(val)
      // this.$store.state.project.startreport=val
      // this.$forceUpdate()
    },
    upload () {
      let self = this
      let version = []
      if (!this.version) {
        this.$message.error(this.$t('device.selectOneVersion'))
        return
      }
      version = this.versions.filter(v => { return v.innerid == this.version })
      if (version.length == 0) {
        this.$message.error(this.$t('device.selectOneVersion'))
        return
      }
      this.Common.mqttSend(this.$store.state.project.srcaddress, {
        devupdate: {
          devprotoid: version[0].protocolid,
          url: 'http://116.62.108.68:8000/resource/' + version[0].uuid, // self.version.storage_uri,
          md5: version[0].md5,
          version: version[0].versionno
        }
      })
      Vue.axios
        .post('/equipment/version/log/add', {versionid: version[0].innerid, srcaddress: [this.$store.state.project.srcaddress]})
        .then((res) => {
        })
    },
    reboot () {
      this.Common.mqttSend(this.$store.state.project.srcaddress, {'reboot': 'null'})
    },
    reflocat () {
      this.Common.mqttSend(this.$store.state.project.srcaddress, {'reflocat': ''})
    },
    sync () {
      let routerkey = 'server/00000000000000000000000000000001/' + this.$store.state.project.srcaddress
      if (this.$store.state.project.srcaddress.length == 8) {
        routerkey = 's/1/' + this.$store.state.project.srcaddress
      }
      this.Common.mqttSend('0', {getAllDevAllDpSta: 'save'}, routerkey)
      this.$message({
        showClose: true,
        message: '发送完毕',
        type: 'success'
      })
    },
    updatemiBee () {
      if (!this.$store.state.project.currentversion || !this.$store.state.project.fotatype) {
        this.$message({
          showClose: true,
          message: '请先配置固件版本信息',
          type: 'error'
        })
        reutrn
      }
      this.Common.mqttSend(this.$store.state.project.srcaddress, {
        servercmd: {
          cmd: 'fota',
          type: this.$store.state.project.fotatype,
          ver: this.$store.state.project.currentversion
        }
      })
      this.updating = true
      let self = this
      setTimeout(function () {
        self.updating = false
        self.$forceUpdate()
        self.$notify({
          title: self.$t('device.updateVersionSuccess'),
          message: self.$t('device.refreshWebAfterUpdate'),
          position: 'bottom-right',
          type: 'success',
          duration: 0
        })
      }, 30000)
    },
    updateEquipment: function (tag) {
      let obj = {}
      obj.innerid = this.$store.state.project.innerid
      tag.forEach(t => {
        if (this.$store.state.project[t] == null || this.$store.state.project[t] == undefined) {
          this.$message({
            showClose: true,
            message: this.$t('base.noParam'),
            type: 'error'
          })
          throw Error(this.$t('base.noParam'))
        }
        obj[t] = this.$store.state.project[t]
      })

      Vue.axios
        .post('/equipment/update',
          obj
        )
        .then((res) => {
          if (res.data.errcode === 0) {
            this.$message({
              showClose: true,
              message: this.$t('base.saveSuccess'),
              type: 'success'
            })
            if (tag.indexOf('startreset') >= 0) {
              this.$store.state.project.autoreset = 1
            }
            this.$forceUpdate()
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    },
    sendMessage: function () {
      let self = this
      this.$prompt('请输入网关协议', '提示', {
        distinguishCancelAndClose: true,
        inputPlaceholder: '请输入网关协议',
        confirmButtonText: '发送',
        cancelButtonText: '模拟服务器发送',
        beforeClose: (action, instance, done) => {
          if (action == 'close') {
            done()
          } else {
            if (!instance.inputValue || instance.inputValue.length == 0) {
              this.$message({
                showClose: true,
                message: '请输入协议内容',
                type: 'error'
              })
              return
            }
            
            try {
              let obj = JSON.parse(instance.inputValue)
              if (action === 'confirm') {
                self.Common.mqttSend(this.$store.state.project.srcaddress, obj)
              } else if (action === 'cancel') {
                let router = 'server/00000000000000000000000000000001/' + this.$store.state.project.srcaddress
                if (self.$store.state.project.srcaddress.length == 8) {
                  router = 's/1/' + this.$store.state.project.srcaddress
                }
                self.Common.mqttSend('0', obj, router)
              }
              this.$message({
                showClose: true,
                message: '协议发送成功',
                type: 'success'
              })
              done()
            } catch (e) {
              this.$message({
                showClose: true,
                message: '协议格式错误',
                type: 'error'
              })
            }
          }
        }
      })
    },
    protocolUpdate: function () {
      if (!this.protocol) {
        this.$message({
          message: this.$t('device.chooseProtocol'),
          type: 'error'
        })
        return
      }
      console.log(this.protocol)

      let self = this
      this.$confirm(
        this.$t('device.changeProtocolConfirm'),
        this.$t('base.info'),
        {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let obj = {
            protocolUpdate: {
              protocol: this.protocol,
              srcaddress: this.$store.state.project.srcaddress
            }
          }
          this.Common.mqttSend('0', obj, 'heart/' + this.Common.mqttClientid + '/srv')
        })
        .catch(() => {})
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Devices/Mibee.vue